class AddressModal {
  locationWrapper;
  addressOverlay;
  addressOverlayContainer;
  closeButton;
  addressButton;
  touchStartY = 0;
  touchEndY = 0;

  // constructor() {
  //   this.init();
  // }

  init() {
    this.locationWrapper = document.querySelector('.mobile-overlay__location-wrapper');
    this.addressOverlay = document.querySelector('.address-overlay');
    this.addressOverlayContainer = document.querySelector('.address-overlay__container');
    this.closeButton = document.querySelector('.address-overlay__close-button');
    this.addressButton = document.querySelector('.address-overlay__button');

    this.locationWrapper.addEventListener('click', () => {
      this.handleLocationWrapperClick();
      this.addressButton.addEventListener('click', this.handleAddressButtonClick.bind(this));
      document.addEventListener('click', this.handleDocumentClick.bind(this));
      this.closeButton.addEventListener('click', this.handleCloseButtonClick.bind(this));
      document.addEventListener('keydown', this.handleEscKeyPress.bind(this));
      if (this.isMobileScreen()) {
        this.addMobileEventListeners();
      } else {
        this.removeMobileEventListeners();
      }
    });
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  isMobileScreen() {
    return window.innerWidth < 992;
  }

  async showAddressModal() {
    if (this.isMobileScreen()) {
      await this.delay(10);
    }
    this.addressOverlayContainer.classList.add('address-overlay__container--show');
  }

  async hideAddressModal() {
    if (this.isMobileScreen()) {
      await this.delay(300);
    }
    this.addressOverlayContainer.classList.remove('address-overlay__container--show');
    if (this.isMobileScreen()) {
      await this.delay(200);
    }
    this.addressOverlay.classList.add('address-overlay--close');
    this.removeAddressModalEventListeners();
  }

  handleLocationWrapperClick() {
    if (this.addressOverlay && this.addressOverlayContainer) {
      this.addressOverlay.classList.remove('address-overlay--close');
      this.showAddressModal();
    }
  }

  handleTouchStart(evt) {
    this.touchStartY = evt.touches[0].clientY;
  }

  handleTouchMove(evt) {
    this.touchEndY = evt.touches[0].clientY;
  }

  handleTouchEnd() {
    if (this.touchStartY < this.touchEndY) {
      const distance = this.touchEndY - this.touchStartY;
      if (distance > 50) {
        this.hideAddressModal();
      }
    }
    this.touchStartY = 0;
    this.touchEndY = 0;
  }

  handleDocumentClick(event) {
    if (this.addressOverlay && this.addressOverlayContainer && !this.addressOverlay.classList.contains('address-overlay--close')) {
      if (!this.addressOverlayContainer.contains(event.target) && !this.locationWrapper.contains(event.target)) {
        this.hideAddressModal();
      }
    }
  }

  handleCloseButtonClick() {
    this.hideAddressModal();
  }

  handleAddressButtonClick() {
    const checkedRadio = document.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const addressText = checkedRadio.nextElementSibling.nextElementSibling.textContent;
      const parts = addressText.split(', ');
      const city = parts[0].replace('г. ', '');
      const address = parts.slice(1).join(', ');
      const citySpan = document.querySelector('.mobile-overlay__city');
      const addressSpan = document.querySelector('.mobile-overlay__address');
      citySpan.textContent = city;
      addressSpan.textContent = address;
      this.hideAddressModal();
    }
  }

  handleEscKeyPress(event) {
    if (event.key === 'Escape') {
      this.hideAddressModal();
    }
  }

  addMobileEventListeners() {
    this.addressOverlayContainer.addEventListener('touchstart', this.handleTouchStart.bind(this));
    this.addressOverlayContainer.addEventListener('touchmove', this.handleTouchMove.bind(this));
    this.addressOverlayContainer.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  removeMobileEventListeners() {
    this.addressOverlayContainer.removeEventListener('touchstart', this.handleTouchStart.bind(this));
    this.addressOverlayContainer.removeEventListener('touchmove', this.handleTouchMove.bind(this));
    this.addressOverlayContainer.removeEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  removeAddressModalEventListeners() {
    this.addressButton.removeEventListener('click', this.handleAddressButtonClick.bind(this));
    document.removeEventListener('click', this.handleDocumentClick.bind(this));
    this.closeButton.removeEventListener('click', this.handleCloseButtonClick.bind(this));
    document.removeEventListener('keydown', this.handleEscKeyPress.bind(this));
    this.removeMobileEventListeners();
  }
}

export const addressModal = new AddressModal();
